module.exports = __webpack_public_path__ + "img/image_registro.5dd30780.png";